import UserIndexView from './UserIndexView'
export default UserIndexView;